import React, { useEffect, useState } from "react";
import { Button, Card, Form, FormProps, message, Modal, Select } from "antd";
import { Subfolder } from "../../redux/interfaces/folder.types.ts";
import { PlusOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import {
  addBaseRequirement,
  fetchAllBaseRequirements,
} from "../../redux/actions/baseRequirementsActions.tsx";
import { fetchFolderById } from "../../redux/actions/folderActions.tsx";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

interface Props {
  subfolders: Subfolder[];
}

type FormValues = {
  subfolder_pk: string;
  base_requirement: string;
};

export const AddBaseRequirement: React.FC<Props> = ({ subfolders }) => {
  const [form] = Form.useForm<FormValues>();
  const dispatch = useAppDispatch();

  const [messageApi, contextHolder] = message.useMessage();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { results: baseRequirements, loading } = useAppSelector(
    (state) => state.baseRequirements,
  );
  const { activeFolder } = useAppSelector((state) => state.folder);

  useEffect(() => {
    onFetchBaseRequirements();
  }, []);

  const onFetchBaseRequirements = async () => {
    await dispatch(
      fetchAllBaseRequirements(`/docvault/base-requirements/?limit=1000`),
    );
  };

  const onAddBaseRequirement: FormProps<FormValues>["onFinish"] = async (
    values: FormValues,
  ) => {
    try {
      await dispatch(addBaseRequirement(values)).unwrap();
      await dispatch(fetchFolderById(activeFolder!.id)).unwrap();
      messageApi.success("Requisito agregado correctamente");

      onClosedModal();
      form.resetFields();
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo agregar el requisito."));
    }
  };

  const onClosedModal = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const onOpenModal = () => {
    setIsModalVisible(true);
  };

  return (
    <div>
      {contextHolder}
      <Modal
        title="Agregar requisito"
        open={isModalVisible}
        onCancel={onClosedModal}
        footer={
          <div>
            <Button
              icon={<PlusOutlined />}
              type="primary"
              onClick={() => form.submit()}
              className="mt-4"
            >
              Agregar
            </Button>
          </div>
        }
      >
        <Card>
          <div className="flex items-center w-full overflow-hidden !border-none">
            <Form
              form={form}
              onFinish={onAddBaseRequirement}
              className="w-full"
            >
              <Form.Item<FormValues>
                label="Subfolder"
                labelCol={{ span: 24 }}
                name="subfolder_pk"
                rules={[{ required: true, message: "Este campo es requerido" }]}
              >
                <Select className="w-full" placeholder="Selecciona una carpeta">
                  {subfolders.map((subfolder) => (
                    <Select.Option key={subfolder.id} value={subfolder.id}>
                      {subfolder.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item<FormValues>
                label="Requisito"
                labelCol={{ span: 24 }}
                name="base_requirement"
                rules={[{ required: true, message: "Este campo es requerido" }]}
              >
                <Select
                  className="w-full"
                  placeholder="Selecciona un requisito"
                >
                  {baseRequirements.map((base) => (
                    <Select.Option key={base.id} value={base.id}>
                      {base.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </div>
        </Card>
      </Modal>
      <Button
        type="link"
        onClick={onOpenModal}
        loading={loading}
        icon={<PlusOutlined />}
      >
        Agregar requisito
      </Button>
    </div>
  );
};
